import styled from '@emotion/styled';
import Colors from '../theme/colors';

export const Text1 = styled.h1`
  color: ${Colors.text_1};
  font-size: 52px;
  font-style: normal;
  font-weight: 900;
  line-height: 130%; /* 67.6px */

  @media print {
    font-size: 32px;
  }

  @media (max-width: 1044px) {
    font-size: 36px;
    line-height: 140%;
  }
`;
